import { GET_USERS_PENDING, GET_USERS_SUCCESS, GET_USERS_ERROR, GET_USERS_INIT } from './types'
import initialState from './initialState'

const reducer = (state = initialState, action: any) => {
  switch (action.type) {
    case GET_USERS_INIT:
      return {
        ...state,
        pending: false,
        success: false,
        error: false,
        data: null
      }

    case GET_USERS_PENDING:
      return {
        ...state,
        pending: true,
        success: false,
        error: false,
        data: null
      }

    case GET_USERS_SUCCESS:
      return {
        ...state,
        pending: false,
        success: true,
        error: false,
        data: action.data
      }

    case GET_USERS_ERROR:
      return {
        ...state,
        pending: false,
        success: false,
        error: true,
        data: null
      }

    default:
      return state
  }
}

export default reducer